import React, {useContext, useEffect, useState} from 'react';
import { PersonaContext } from '../../lib/personaContext.js';
import { PersonaPageContext } from './personaPageContext.js';
import useProductsApi from '@/products/lib/useProductsApi.js';
import useExperienceApi from '../../../experiences/lib/useExperienceApi';
import { useSharedExperiencesApi } from '@/shared-experiences/lib/useSharedExperiencesApi';
import { AuthContext } from '@/auth/lib/authContext.js';
import { useLocation } from 'react-router-dom';
export default function PersonaPageProvider({children}) {
  const {
    personaId, 
  } = useContext(PersonaContext);
  const {profile} = useContext(AuthContext)
  const productApi = useProductsApi();
  const experienceApi = useExperienceApi();
  const sharedExperiencesApi = useSharedExperiencesApi();
  const [isFetchingProducts, setIsFetchingProducts] = useState(false);
  const [isFetchingExperiences, setIsFetchingExperiences] = useState(false);
  const [isFetchingSharedExperiences, setIsFetchingSharedExperiences] = useState(false);
  const [isFetchingExtendedPersonas, setIsFetchingExtendedPersonas] = useState(false);
  const [productList, setProductList] = useState([]);
  const [experienceList, setExperienceList] = useState(null);
  const [experienceGroupList, setExperienceGroupList] = useState(null);
  const [experiencesProducts, setExperiencesProducts] = useState(null);
  const [sharedExperienceList, setSharedExperienceList] = useState(null);
  const [init, setInit] = useState(false);
  const [editingBio, setEditingBio] = useState(false);
  const [editingQuote, setEditingQuote] = useState(false);
  const [editingAttributes, setEditingAttributes] = useState(false);
  const [editingUsefulLinks, setEditingUsefulLinks] = useState(false);
  const [addingSharedExperience, setAddingSharedExperience] = useState(false);
  const [previousPersonaId, setPreviousPersonaId] = useState(null);
  const [group, setGroup] = useState(null);
  const [parentGroup, setParentGroup] = useState(null);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const groupId = searchParams.get('group-id');
  const refreshProductList = async () => {
    try {
      setIsFetchingProducts(true);
      const newProductList = await productApi.fetchProductsByPersonaId(personaId);
      setProductList(newProductList);
      setIsFetchingProducts(false);
    } catch (error) {
      console.error(error)
    }
  }
  const refreshSharedExperienceList = async () => {
    try {
      setIsFetchingSharedExperiences(true);
      const newSharedExperienceList = await sharedExperiencesApi.fetchSharedExperiencesByPersonaId(personaId);
      setSharedExperienceList(newSharedExperienceList || []);
      setIsFetchingSharedExperiences(false);
    } catch (error) {
      console.error('❌ Error in refreshSharedExperienceList:', error);
      setIsFetchingSharedExperiences(false);
    }
  }
  const refreshExperienceList = async () => {
    try {
      setIsFetchingExperiences(true);
      const result = await Promise.all([
        experienceApi.fetchExperiencesByPersonaId(personaId),
        experienceApi.fetchExperienceGroupsByPersonaId(personaId),
        productApi.fetchProductsWithExperienceByPersonaId(personaId)
      ]);
      setExperienceList((result[0] || []));
      setExperienceGroupList(result[1] || []);
      setExperiencesProducts(result[2]);
    } catch (error) {
      console.error('❌ Error in refreshExperienceList:', error);
    } finally {
      setIsFetchingExperiences(false);
    }
  }
  useEffect(() => {
    if (personaId && profile) {
      if(!init || personaId !== previousPersonaId) {
        setPreviousPersonaId(personaId)
        refreshProductList();
        refreshExperienceList();
        refreshSharedExperienceList();
        setInit(true);
      }
    }
  }, [personaId,  profile]);
  useEffect(() => {
    if (experienceGroupList) {
      if (groupId) {
        const newGroup = (experienceGroupList.filter(g => g.id === parseInt(groupId)))[0];
        setGroup(newGroup);
        if(newGroup) {
          const parentGroup = experienceGroupList.find(g => newGroup.group_id === g.group.id);  
          setParentGroup(parentGroup);
        }
      } else {
        setGroup(null);
        setParentGroup(null);
      }
    }
  }, [groupId, experienceGroupList]);
  return (
    <PersonaPageContext.Provider value={{
      isFetchingProducts,
      isFetchingExperiences,
      isFetchingSharedExperiences,
      productList,
      experienceGroupList,
      refreshProductList: refreshProductList,
      refreshExperienceList: refreshExperienceList,
      refreshSharedExperienceList: refreshSharedExperienceList,
      isFetchingExtendedPersonas,
      experiencesProducts,
      experienceList,
      sharedExperienceList,
      editingBio,
      editingQuote,
      editingAttributes,
      editingUsefulLinks,
      setEditingBio,
      setEditingQuote,
      setEditingAttributes,
      setEditingUsefulLinks,
      addingSharedExperience,
      setAddingSharedExperience,
      group,
      parentGroup,
      setGroup,
    }}>
      {children}
    </PersonaPageContext.Provider>
  );
}